/* Cart stock risk message
   Urgency copy under cart line items for allowlisted SKUs
   when the variant is still available. Cart drawer + cart page. */

(function () {
  if (window.__BM_STOCK_RISK_MSG__) return;
  window.__BM_STOCK_RISK_MSG__ = true;

  var TARGET_SKUS = {
    '2003TBAK0487': true,
    '2003KASE0181': true,
    '2003TBAK0505': true,
    '2003TBAK0507': true,
    '2003TBAK0482': true,
    '2003KASE0193': true,
    '2003TZBR0032': true,
    '2003TBAK0506': true,
    '2003TBAK0508': true,
    '2003TBAK0511': true,
    '2003KASE0194': true,
    '2003TBAK0503': true,
    '2003TBAK0512': true,
    '2003TBAK0489': true,
    '2003TBAK0481': true,
    '2003TBAK0509': true,
    '2003TBAK0513': true,
    '2003TBAK0504': true,
    '2003TBAK0488': true,
    '2003TBSN0241': true,
    '2003KASE0191': true,
    '2003TBAK0483': true,
    '2003KDEH0013': true,
    '2003TBAK0510': true,
    '2003TBAK0485': true,
    '2003TBAK0573': true,
    '2003TBAK0574': true,
    '2003CAYF0040': true,
    '2003YMTK0177': true,
    '2003TBKS0351': true,
    '2003YMTK0215': true,
    '2003KAST0086': true
  };

  var MESSAGE =
    'High risk of selling out again. Only available while supplies last.';
  var CLASS_NAME = 'bm-stock-risk-message';
  var ATTR = 'data-bm-stock-risk';

  var scheduled = false;
  var applying = false;
  var productCache = Object.create(null);
  var cartPromise = null;

  function normalizeSku(sku) {
    return String(sku || '')
      .trim()
      .toUpperCase()
      .replace(/\s+/g, '');
  }

  function isTargetSku(sku) {
    return !!TARGET_SKUS[normalizeSku(sku)];
  }

  function fetchJson(url) {
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error(String(response.status));
      return response.json();
    });
  }

  function getCart() {
    if (cartPromise) return cartPromise;
    cartPromise = fetchJson('/cart.js')
      .catch(function () {
        return { items: [] };
      })
      .then(function (cart) {
        cartPromise = null;
        return cart;
      });
    return cartPromise;
  }

  function getProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];

    productCache[handle] = fetchJson('/products/' + encodeURIComponent(handle) + '.js')
      .catch(function () {
        return null;
      })
      .then(function (product) {
        if (!product) delete productCache[handle];
        return product;
      });

    return productCache[handle];
  }

  function findVariant(product, variantId) {
    if (!product || !Array.isArray(product.variants)) return null;
    var id = Number(variantId);
    for (var i = 0; i < product.variants.length; i += 1) {
      var variant = product.variants[i];
      if (Number(variant.id) === id) return variant;
    }
    return null;
  }

  function resolveItemState(item) {
    if (!item) {
      return Promise.resolve({ sku: '', available: false, isTarget: false });
    }

    return getProduct(item.handle).then(function (product) {
      var variant = findVariant(product, item.variant_id || item.id);
      var sku = normalizeSku((variant && variant.sku) || item.sku || '');
      var available = false;

      if (variant && typeof variant.available === 'boolean') {
        available = variant.available;
      } else if (typeof item.available === 'boolean') {
        available = item.available;
      }

      return {
        sku: sku,
        available: available,
        isTarget: isTargetSku(sku)
      };
    });
  }

  function cartItemNodes() {
    var nodes = [];
    var drawerItems = document.querySelectorAll('cart-drawer li.cart-item, #CartDrawer li.cart-item');
    var pageItems = document.querySelectorAll(
      'main-cart tr.cart-item, form#cart tr.cart-item, .cart-items tr.cart-item'
    );

    Array.prototype.forEach.call(drawerItems, function (node) {
      nodes.push(node);
    });
    Array.prototype.forEach.call(pageItems, function (node) {
      nodes.push(node);
    });

    return nodes;
  }

  function getVariantIdFromNode(node) {
    if (!node) return null;
    if (node.getAttribute('data-variant-id')) {
      return String(node.getAttribute('data-variant-id'));
    }
    var qty = node.querySelector('[data-quantity-variant-id]');
    if (qty && qty.getAttribute('data-quantity-variant-id')) {
      return String(qty.getAttribute('data-quantity-variant-id'));
    }
    return null;
  }

  function getLineIndexFromNode(node) {
    if (!node || !node.id) return null;
    var match = node.id.match(/(?:CartDrawer-Item|CartItem)-(\d+)$/);
    return match ? parseInt(match[1], 10) : null;
  }

  function findCartItemForNode(node, items) {
    if (!items || !items.length) return null;

    var variantId = getVariantIdFromNode(node);
    var lineIndex = getLineIndexFromNode(node);

    if (variantId) {
      var matches = items.filter(function (item) {
        return String(item.variant_id) === variantId || String(item.id) === variantId;
      });

      if (matches.length === 1) return matches[0];

      if (matches.length > 1 && lineIndex && items[lineIndex - 1]) {
        var indexed = items[lineIndex - 1];
        if (String(indexed.variant_id) === variantId || String(indexed.id) === variantId) {
          return indexed;
        }
      }

      if (matches.length > 1) return matches[0];
    }

    if (lineIndex && items[lineIndex - 1]) return items[lineIndex - 1];
    return null;
  }

  function findTitleAnchor(node) {
    return (
      node.querySelector('.cart-item__title') ||
      node.querySelector('a.cart-item__title') ||
      node.querySelector('.cart-item__details a')
    );
  }

  function findInsertPoint(node) {
    if (node.matches && node.matches('li.cart-item')) {
      var drawerProduct = node.querySelector(':scope > .cart-item__product');
      if (drawerProduct) {
        return {
          parent: node,
          after: drawerProduct
        };
      }
    }

    if (node.matches && node.matches('tr.cart-item')) {
      var info = node.querySelector('.cart-item__product--info');
      var title = findTitleAnchor(node);
      if (info && title) {
        var titleRow =
          title.closest('.flex.items-center.justify-between') ||
          title.closest('.block') ||
          title.parentElement;
        if (titleRow && info.contains(titleRow)) {
          return {
            parent: titleRow.parentElement,
            after: titleRow
          };
        }
        return {
          parent: info,
          after: info.firstElementChild
        };
      }
    }

    var fallbackTitle = findTitleAnchor(node);
    if (!fallbackTitle) return null;

    var titleBlock = fallbackTitle.closest('.block') || fallbackTitle.parentElement;
    if (!titleBlock || !titleBlock.parentElement) return null;

    return {
      parent: titleBlock.parentElement,
      after: titleBlock
    };
  }

  function placeMessage(node, message) {
    var insert = findInsertPoint(node);
    if (!insert) return null;

    if (insert.after.nextSibling !== message) {
      if (insert.after.nextSibling) {
        insert.parent.insertBefore(message, insert.after.nextSibling);
      } else {
        insert.parent.appendChild(message);
      }
    }

    return message;
  }

  function ensureMessage(node) {
    var existing = node.querySelector('.' + CLASS_NAME);
    if (existing) return placeMessage(node, existing);

    var message = document.createElement('p');
    message.className = CLASS_NAME;
    message.setAttribute(ATTR, '1');
    message.textContent = MESSAGE;

    return placeMessage(node, message);
  }

  function removeMessage(node) {
    var existing = node.querySelectorAll('.' + CLASS_NAME);
    Array.prototype.forEach.call(existing, function (el) {
      el.remove();
    });
  }

  function applyToNode(node, shouldShow) {
    if (shouldShow) {
      ensureMessage(node);
    } else {
      removeMessage(node);
    }
  }

  function sync() {
    if (applying) return;
    applying = true;

    getCart()
      .then(function (cart) {
        var items = Array.isArray(cart.items) ? cart.items : [];
        var nodes = cartItemNodes();

        return Promise.all(
          nodes.map(function (node) {
            var item = findCartItemForNode(node, items);
            if (!item) {
              removeMessage(node);
              return null;
            }

            return resolveItemState(item).then(function (state) {
              applyToNode(node, !!(state.isTarget && state.available === true));
            });
          })
        );
      })
      .catch(function () {})
      .then(function () {
        applying = false;
      });
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      sync();
    });
  }

  function onCartUpdated() {
    productCache = Object.create(null);
    scheduleSync();
  }

  document.addEventListener('cart:updated', onCartUpdated);
  document.addEventListener('cart:refresh', onCartUpdated);

  if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS) {
    try {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, onCartUpdated);
    } catch (e) {}
  }

  var observer = new MutationObserver(function (mutations) {
    if (applying) return;

    for (var i = 0; i < mutations.length; i += 1) {
      var mutation = mutations[i];
      if (mutation.type !== 'childList') continue;

      var nodes = [];
      if (mutation.addedNodes && mutation.addedNodes.length) {
        Array.prototype.forEach.call(mutation.addedNodes, function (node) {
          nodes.push(node);
        });
      }
      if (mutation.removedNodes && mutation.removedNodes.length) {
        Array.prototype.forEach.call(mutation.removedNodes, function (node) {
          nodes.push(node);
        });
      }

      for (var j = 0; j < nodes.length; j += 1) {
        var node = nodes[j];
        if (!node || node.nodeType !== 1) continue;
        if (node.classList && node.classList.contains(CLASS_NAME)) continue;
        if (node.closest && node.closest('.' + CLASS_NAME)) continue;

        if (
          (node.matches &&
            (node.matches(
              'li.cart-item, tr.cart-item, cart-drawer, main-cart, cart-items, #CartDrawer, #MainCart'
            ) ||
              node.querySelector('li.cart-item, tr.cart-item'))) ||
          (node.classList && node.classList.contains('cart-item'))
        ) {
          scheduleSync();
          return;
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }
})();
